import PropTypes from 'prop-types';
import { Btn, Modal } from './index';
import { useState } from 'react';
export default function PlanningOrigins({
  programs,
  regions = [],
  groups = [],
  published = []
}) {
  const [open, setOpen] = useState(false);
  const containers = [...(groups.length ? groups : regions).map((group, index) => ({
    ...group,
    originLabel: groups.length ? `Van ${group.planejamento_van_numero || index + 1}` : group.regiao
  })), ...published.filter(van => van.grupo).map(van => ({
    ...van.grupo,
    originLabel: `Van ${van.grupo.planejamento_van_numero || '?'}`
  }))];
  return <><Btn variant="secondary" size="sm" onClick={() => setOpen(true)}>Ver PGs incluídas ({programs.length})</Btn>
    {open && <Modal title="PGs incluídas no planejamento" maxWidth={720} onClose={() => setOpen(false)}>
      <p className="planning-help">Cada passageiro mantém o vínculo com sua PG. Uma PG pode atender mais de uma van.</p>
      <div className="planning-origins">{programs.map(program => {
          const matches = person => Number(person.programacao_id) === Number(program.id);
          const included = containers.reduce((sum, group) => sum + group.pessoas.filter(matches).length, 0);
          const original = program.passageiros?.length || 0;
          return <div className="planning-origin" key={program.id}>
          <strong>PG {program.codigo}</strong><span>{included} {included === 1 ? 'passageiro incluído' : 'passageiros incluídos'} · {original} no pedido</span>
          <p>{containers.map(group => {
                const count = group.pessoas.filter(matches).length;
                return count ? `${group.originLabel} (${count})` : null;
              }).filter(Boolean).join(' · ') || 'Sem passageiros nesta montagem'}</p>
        </div>;
        })}</div>
    </Modal>}
  </>;
}
PlanningOrigins.propTypes = {
  programs: PropTypes.array.isRequired,
  regions: PropTypes.array,
  groups: PropTypes.array,
  published: PropTypes.array
};
